
import { CSSProperties } from "@mui/material";

export const DialogTitleStyle  : CSSProperties = {
    backgroundColor: '#0A192D',
    fontSize: 22,
    color: 'white',
}

export const DialogContentStyle  : CSSProperties = {
    backgroundColor: '#fff',
}

export const DialogActionsStyle  : CSSProperties = {
    backgroundColor: '#fff',
}

export const DialogSectionStyle  : CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    gap: '14px',
    padding: '14px 16px',
    border: '1px solid #e0e0e0',
    borderRadius: '10px',
}

export const DialogSectionHeaderStyle  : CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
}

export const DialogSectionLabelStyle  : CSSProperties = {
    fontSize: '14px',
    fontWeight: 600,
}